import { InspectionTypeEnum } from '@authority-labs/enums';
import { BaseDto } from '../base.dto';
import { InspectionModel } from './inspection.dto';

export class InspectionTemplate extends BaseDto {
  name: string;
  inspectionType: InspectionTypeEnum;
  description?: string;
  inspection: InspectionModel;
}
